import {useMutation} from 'react-query';
import {client} from './ApiClient';
import {ClubPreferences} from "../Helpers/Types";

const setClubPreferences = ({urls, domain, deviceCode, cartUid, cartExternalId, cartSourceExternalId, lineUid, preferences}: {urls: any; domain: string; deviceCode: string; cartUid: string; cartExternalId: string; cartSourceExternalId: string; lineUid: string; preferences: ClubPreferences}) => {
    const body = {
        CartUid: cartUid,
        CartExternalId: cartExternalId,
        CartSourceExternalId: cartSourceExternalId,
        LineUid: lineUid,
        ...preferences
    }
    return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/carts/commands/setclubpreferences`, {
        body: body
    });
}

export default function useSetClubPreferences() {
    // @ts-ignore
    return useMutation(setClubPreferences)
}